export default "__VITE_PUBLIC_ASSET__5c504197__"